import React from 'react';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import { ServiceManager } from '@jutro/legacy/services';
import _ from 'lodash';
import { MLAddressVerificationModalComponent } from 'ml-components-address-react';
import { MLGeoCompleteService } from 'ml-services-common-react';

const MULTIPLE_ADDRESSES = 'MULTIPLE_ADDRESSES';
const MANUALLY_CHANGED = 'MANUALLY_CHANGED';
const UNABLE_TO_VALIDATE = 'UNABLE_TO_VALIDATE';

const wrapAddress = (address, viewModelService) => {
    const localeService = ServiceManager.getService('locale-service');
    const initialData = {
        addressLine1: address.AddressLine1 || '',
        addressLine2: address.AddressLine2 || '',
        city: address.City || '',
        postalCode: address.PostalCode || '',
        state: address.StateProvince || '',
        country: localeService.getDefaultCountryCode()
    };
    return viewModelService.create(initialData, 'pc', 'edge.capabilities.address.dto.AddressDTO');
};

const extractPropsToCompare = (address) => {
    return (({
        addressLine1, addressLine2, city, postalCode, state
    }) => ({
        addressLine1, addressLine2, city, postalCode, state
    }))(address);
};

const isAddressChanged = (address1, address2) => {
    const a = extractPropsToCompare(address1);
    if (_.isUndefined(a.addressLine2)) {
        a.addressLine2 = '';
    }
    const b = extractPropsToCompare(address2);
    return !_.isEqual(a, b);
};

const showDialog = (typedAddress, addressOptions, mode, productType) => {
    addressOptions.unshift(typedAddress);
    const { modalApi } = _.get(window, '__gifws.modalApi');

    const componentProps = {
        typedAddress,
        addressOptions,
        mode,
        productType
    };

    return modalApi.showModal(
        <MLAddressVerificationModalComponent {...componentProps} />
    );
}

export default {
    validateAddress: async (viewModelService, typedAddress, productType) => {
        return new Promise((resolve, reject) => {
            MLGeoCompleteService.validateAddress(typedAddress.value)
                .then((res) => {
                    const addressOptions = res.map((a) => wrapAddress(a, viewModelService));

                    if (addressOptions.length === 0) {
                        return showDialog(typedAddress, [], UNABLE_TO_VALIDATE, productType).then(resolve);
                    }
                    if (addressOptions.length === 1
                        && isAddressChanged(typedAddress.value, addressOptions[0].value)) {
                        return showDialog(typedAddress, addressOptions, MANUALLY_CHANGED, productType)
                            .then(resolve);
                    }
                    if (addressOptions.length === 1
                        && !isAddressChanged(typedAddress.value, addressOptions[0].value)) {
                        const localDate = MLLocalDateUtil.date2LocalDate(new Date());
                        typedAddress.standardizeStatus_ML.set(true);
                        typedAddress.standardizeOverride_ML.set(false);
                        typedAddress.standardizeDate_ML.set(localDate);
                        typedAddress.validateAddressStatus_ML.set(true);
                        return resolve();
                    }
                    if (addressOptions.length > 1) {
                        return showDialog(typedAddress, addressOptions, MULTIPLE_ADDRESSES, productType)
                            .then(resolve);
                    }
                }).catch((error) => {
                    console.error(error);
                    if (error === 'editAddress') {
                        return reject();
                    }
                    return showDialog(typedAddress, [], UNABLE_TO_VALIDATE, productType).then(resolve);
                });
        });
    }
};
